import 'devicon/devicon.css';
import 'font-awesome/css/font-awesome.min.css';

export interface ILanguage {
  value: string;
  label: string;
  icon: string;
  initialCode: string;
  executable: boolean;
}

export const languages: Array<ILanguage> = [
  {
    value: 'PlainText',
    label: 'Plain Text',
    icon: 'fa fa-file-text',
    initialCode: 'Hello Pramp!',
    executable: false,
  },
  {
    value: 'C',
    label: 'C',
    icon: 'icon--c',
    initialCode: `#include <stdio.h>
#include <stdlib.h>

int main(void)
{
  puts("Hello Pramp!");
  return EXIT_SUCCESS;
}`,
    executable: true,
  },
  {
    value: 'C#',
    label: 'C#',
    icon: 'icon--csharp',
    initialCode: `class HelloWorld
{
    static void Main()
    {
        System.Console.WriteLine("Hello Pramp!");
    }
}`,
    executable: true,
  },
  {
    value: 'C++',
    label: 'C++',
    icon: 'icon--cplusplus',
    initialCode: `#include <iostream>

int main()
{
    std::cout << "Hello Pramp!" << std::endl;
    return 0;
}`,
    executable: true,
  },
  {
    value: 'Clojure',
    label: 'Clojure',
    icon: 'icon--clojure',
    initialCode: `(defn hello []
  (println "Hello Pramp!"))

(hello)`,
    executable: true,
  },
  {
    value: 'Go',
    label: 'Go',
    icon: 'devicon-go-plain',
    initialCode: `package main
import "fmt"
func main() {
  fmt.Printf("Hello Pramp!")
}`,
    executable: true,
  },
  {
    value: 'HTML',
    label: 'HTML/CSS/JS',
    icon: 'devicon-html5-plain',
    initialCode: `<!doctype html>
<html>
  <head>
    <title>Hello Pramp!</title>
  </head>
</html>`,
    executable: false,
  },
  {
    value: 'Haskell',
    label: 'Haskell',
    icon: 'icon--haskell',
    initialCode: `main = putStrLn "Hello Pramp!"`,
    executable: true,
  },
  {
    value: 'Java',
    label: 'Java',
    icon: 'devicon-java-plain',
    initialCode: `class Main {
  static public void main( String args[] ) {
    System.out.println( "Hello Pramp!" );
  }
}`,
    executable: true,
  },
  {
    value: 'JavaScript',
    label: 'JavaScript',
    icon: 'devicon-javascript-plain',
    initialCode: `console.log('Hello Pramp!');`,
    executable: true,
  },
  {
    value: 'PHP',
    label: 'PHP',
    icon: 'devicon-php-plain',
    initialCode: `echo 'Hello Pramp!';`,
    executable: true,
  },
  {
    value: 'Python',
    label: 'Python',
    icon: 'devicon-python-plain',
    initialCode: `print "Hello Pramp!"`,
    executable: true,
  },
  {
    value: 'Ruby',
    label: 'Ruby',
    icon: 'devicon-ruby-plain',
    initialCode: `puts "Hello Pramp!"`,
    executable: true,
  },
  {
    value: 'Swift',
    label: 'Swift',
    icon: 'icon--swift',
    initialCode: `print("Hello Pramp!")`,
    executable: true,
  },
];

export const getLanguage = language => languages.find(a => a.value === language);
